import { createRouter, createWebHistory } from 'vue-router'
import SeedJung_Main from '@/components/SeedJung_Main.vue'
import SeedJung_Header from '@/components/SeedJung_Header.vue'
import SeedJung_Introduction from '@/components/SeedJung_Introduction.vue'
import SeedJung_CounselorList from '@/components/SeedJung_CounselorList.vue'
import SeedJung_Counselor_YSC from '@/components/SeedJung_Counselor_YSC.vue'
import SeedJung_Consulting from '@/components/SeedJung_Consulting.vue'
import SeedJung_ConsultationDetail from '@/components/SeedJung_ConsultationDetail.vue'
import SeedJung_Review from '@/components/SeedJung_Review.vue'
import SeedJung_Login from '@/components/SeedJung_Login.vue'
import SeedJung_Regist from '@/components/SeedJung_Regist.vue'
import SeedJung_Inquiry from '@/components/SeedJung_Inquiry.vue'
import SeedJung_Mypage from '@/components/SeedJung_Mypage.vue'
import store from '../store'

const routes = [
  {
    path: '/',
    name: 'home',
    components: {
      default: SeedJung_Main,
      SeedJung_Header
    }
  },
  {
    path: '/mypage',
    name: 'mypage',
    components: {
      default: SeedJung_Mypage,
      SeedJung_Header
    },
    meta: { requiresAuth: true }
  },  
  {
    path: '/about',
    name: 'about',    
    components: {
      default: SeedJung_Introduction,
      SeedJung_Header
    }
  },
  {
    path: '/counselor',
    name: 'counselor',
    components: {
      default: SeedJung_CounselorList,
      SeedJung_Header
    }
  },
  {
    path: '/consulting',
    name: 'consulting',    
    components: {
      default: SeedJung_Consulting,
      SeedJung_Header
    },
    // meta: { requiresAuth: true }  // 로그인 필요
  },
  {
    path: '/counselor/ysc',
    name: 'counselor-ysc',
    components: {
      default: SeedJung_Counselor_YSC,
      SeedJung_Header
    }
  },  
  {
    path: '/review',
    name: 'review',        
    components: {
      default: SeedJung_Review,
      SeedJung_Header
    }
  },
  {
    path: '/login',
    name: 'login',    
    components: {
      default: SeedJung_Login,
      SeedJung_Header
    }
  },
  {
    path: '/regist',
    name: 'regist',    
    components: {
      default: SeedJung_Regist,
      SeedJung_Header
    }
  },
  {
    path: '/inquiry',
    name: 'inquiry',    
    components: {
      default: SeedJung_Inquiry,
      SeedJung_Header
    },
    // meta: { requiresAuth: true }  // 로그인 필요
  },
  {
    path: '/consultation/:id',
    name: 'consultation',
    components: {
      default: SeedJung_ConsultationDetail,
      SeedJung_Header
    },
    props: { default: true }
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

// HTTPS 리다이렉션 로직 추가
router.beforeEach((to, from, next) => {
  console.log('Current protocol:', location.protocol);
  console.log('NODE_ENV:', process.env.NODE_ENV);
  if (process.env.NODE_ENV === 'production' && location.protocol !== 'https:') {
    location.replace(`https://${location.hostname}${location.pathname}${location.search}`)
  } else {
    const requiresAuth = to.matched.some(record => record.meta.requiresAuth)
    const isLoggedIn = store.getters.isLoggedIn

    if (requiresAuth && !isLoggedIn) {
      next('/login')
    } else {
      next()
    }
  }
})

export default router